//
// Module for the Tax Tables and Rates add new table view
//
rs.module("system_/configuration/taxtablesandrates/addnewtable",

    [
        "controls/components/event-banner",
        "common/select-helper",
        "common/visibility"
    ],

    function (eventBanner, selectHelper, visibility) {

        // Initialize the module
        function initialize(jsSelectors, federalTaxType, taxTableDetailGrid) {

            // Unpack js Selectors
            var criteria = $.js(jsSelectors.criteria);

            var fedFilingDiv = criteria.js(jsSelectors.fedFilingDiv);
            var stateFilingDiv = criteria.js(jsSelectors.stateFilingDiv);

            var taxTypeSelect = criteria.js(jsSelectors.taxTypeSelect);
            var stateSelect = criteria.js(jsSelectors.stateSelect);
            var stateFilingSelect = criteria.js(jsSelectors.stateFilingSelect);
            var fedFilingSelect = criteria.js(jsSelectors.fedFilingSelect);
            var taxDetailGridError = criteria.js(jsSelectors.taxDetailGridError);
            var taxTableGridAddButton = criteria.js(jsSelectors.taxTableGridAddButton);

            // Get select helper(s)
            var stateSelectHelper = selectHelper.getHelper(stateSelect);
            var stateFilingSelectHelper = selectHelper.getHelper(stateFilingSelect);
            var fedFilingSelectHelper = selectHelper.getHelper(fedFilingSelect);

            // On tax type change, determine if the state drop down is still enabled.
            taxTypeSelect.change(function () {
                stateSelectHelper.setDisabled(taxTypeSelect.val() == federalTaxType);
                stateSelectHelper.setValue('');

                visibility.setVisible(fedFilingDiv, taxTypeSelect.val() == federalTaxType);
                fedFilingSelectHelper.setDisabled(taxTypeSelect.val() != federalTaxType);

                visibility.setVisible(stateFilingDiv, taxTypeSelect.val() != federalTaxType);
                stateFilingSelectHelper.setDisabled(taxTypeSelect.val() == federalTaxType);
            });

            // On tax table add button click, add a new row.
            taxTableGridAddButton.click(function () {
                eventBanner.removeAllMessages();
                taxDetailGridError.text('');
                taxTableDetailGrid.addRow();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);